import { render, staticRenderFns } from "./correos-print-controls.vue?vue&type=template&id=72cabb1c&scoped=true"
import script from "./correos-print-controls.vue?vue&type=script&lang=js"
export * from "./correos-print-controls.vue?vue&type=script&lang=js"
import style0 from "./correos-print-controls.vue?vue&type=style&index=0&id=72cabb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cabb1c",
  null
  
)

export default component.exports